<template>
  <div class="container-fluid actor-section" v-if="content">
    <div class="row">
      <div class="actor-info col-md-6 col-12 my-auto">
        <div class="ml-0 ml-md-5 row">
          <div class="col">
            <div class="row mt-5 mt-md-0">
              <div class="col text-md-left text-center">
                <h2 class="actor-name">
                  {{ content.metadata.name }}
                </h2>
                <div class="actor-name-divider mx-auto mx-md-0"></div>
              </div>
            </div>
            <div class="row mt-5 mt-md-0">
              <p
                class="actor-description text-center text-md-left col-12 col-md-9"
                v-if="null !== content.metadata.description"
              >
                {{ content.metadata.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col text-center text-md-left mb-5">
        <lazy-image
          class="bordered-image actor-picture"
          :src="content.metadata.picture"
          :title="content.metadata.name"
          :alt="content.metadata.name"
        />
      </div>
    </div>

    <swiper
      class="actors-slider"
      :modules="modules"
      :slides-per-view="slidesPerView"
      :space-between="5"
      :navigation="!isMobile()"
      :pagination="false"
      :scrollbar="false"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="(asset, i) in contentAssets" v-bind:key="i">
        <horizontal-card-clean :asset="asset" v-if="isMobile()" />
        <horizontal-card v-else :asset="asset" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import { A11y, Navigation, Pagination, Scrollbar } from "swiper";
import HorizontalCard from "./carousel/HorizontalCard.vue";
import HorizontalCardClean from "@/components/landing/carousel/HorizontalCardClean.vue";
import LazyImage from "@/components/utils/LaziImage.vue";
import { mapState } from "pinia";
import { UIStore } from "../../stores/uiStore";

export default {
  name: "FeaturedActors",
  components: {
    LazyImage,
    HorizontalCardClean,
    HorizontalCard,
    Swiper,
    SwiperSlide,
  },
  props: {
    content: {
      type: Object,
      default: null,
    },
    limit_movies: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(UIStore, ["getCurrentWidth"]),
    slidesPerView() {
      let count = this.$breakpoints("featured_actors", this.getCurrentWidth);
      return this.content.assets.length >= count ? count : this.content.assets.length;
    },
    contentAssets() {
      return this.limit_movies
        ? this.content.assets.splice(0, 4)
        : this.content.assets;
    },
  },
  methods: {
    onSwiper(swiper) {},
    onSlideChange() {},
    onSwiperReachEnd(swiper) {},
  },
  setup() {
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/colors";

.bordered-image {
  padding: 10px;
  border-radius: 10px;
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(11, 16, 25, 0.3) 50%,
    rgba(46, 58, 80, 0.8) 100%
  );
}

.webp {
  .actor {
    &-section {
      background: linear-gradient(
          356.13deg,
          rgba(20, 28, 45, 0.3) -13.92%,
          rgba(19, 28, 45, 0.3) 121.92%
        ),
        url("@/assets/img/quotes.webp") no-repeat center 2em;
      background-size: cover, 6%;

      &:before {
        content: "";
        display: block;
        height: 0.5px;
        background: url("@/assets/img/divider-line.webp") no-repeat center
          center;
      }
    }
    &-description {
    }
    &-name-divider {
      display: block;
      height: 1px;
      width: 200px;
      margin: 0.5em;
      background: url("@/assets/img/divider-short.webp") no-repeat center left;
    }
    &-picture {
      border-radius: 16px;
      // width: 330px;
      // height: 432px;
      margin-top: 3em;
    }
  }
}

.actor {
  &-section {
    background: linear-gradient(
        356.13deg,
        rgba(20, 28, 45, 0.3) -13.92%,
        rgba(19, 28, 45, 0.3) 121.92%
      ),
      url("@/assets/img/quotes.png") no-repeat center 3em;
    background-size: cover, 6%;

    &:before {
      content: "";
      display: block;
      height: 0.5px;
      background: url("@/assets/img/divider-line.png") no-repeat center center;
    }

  }
  &-name{
    font-size: 3rem;
  }
  &-description {
    font-size: 1.3rem;
  }
  &-name-divider {
    display: block;
    height: 1px;
    width: 200px;
    margin: 0.5em;
    background: url("@/assets/img/divider-short.png") no-repeat center left;
  }
  &-picture {
    border-radius: 16px;
    max-width: 400px;
    width: 80%;
    // width: 330px;
    // height: 432px;
    margin-top: 3em;
    @media (min-width: 1920px) {
      width: 35%;
    }
  }
}


@media (min-width: 1920px) {
  .actor {
    &-name{
      font-size: 2.3vw;
    }
    &-description {
      font-size: 1.1vw;
    }
  }
  .actors-slider{
    font-size: 0.8vw;
  }
}

@media (min-width: 3840px) {

  .actor {
    &-name{
      font-size: 5em;
    }
    &-description {
      font-size: 2.5em;
    }
  }
  
}

</style>
